import { FC, Fragment, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { useAppSelector, useAppDispatch } from "../../../../../redux/hook";
import { 
  enableEditorMode, 
  setCurrentEditorWidth, 
  setCurrentEditorHeight, 
  setEditorStatusParams
} from '../../../../../redux/slices/editor/editorSlice'
import * as yup from 'yup'
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAddContentMutation, useGetAllContentsQuery, useUpdateContentMutation } from '../../../../../redux/slices/content/apiContentSlice';
import { AssociativeArray, Content, ContentInput, isEmptyElements, isSimilarContent } from '../../../../../redux/slices/content/contentModels'
import { setCheckSum, setContent, setContentFromTemplate, setContentName, setPrevContent } from '../../../../../redux/slices/content/contentSlice'
import html2canvas from 'html2canvas'
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { useAddTemplateMutation, useGetAllTemplatesQuery } from '../../../../../redux/slices/template/apiTemplateSlice';
import { Position, Template } from '../../../../../redux/slices/template/templateModels';
import { setIsTemplateEditor, setPrevTemplate, setTemplateName } from '../../../../../redux/slices/template/templateSlice';

const schema = yup.object().shape({  
  // contentId: yup.string(),
  // template_id: yup.string(),
  // template_name : yup.string().min(1, 'min. one characher').required('Required'),
  // width: yup.number().required(),
  // height: yup.number().required(),
  // target_layout: yup.number().required(),   //0: landscape, 1: portrait
  // category: yup.number().required(),    //1: public, 2: private
  // positions: yup.mixed().required('Content is required'),
})

// -------------------------------------
const SaveTemplateFrm = () => {

  const dispatch = useAppDispatch()
  // ----------------------------------------------------------------------    
  const [addTemplate] = useAddTemplateMutation();

  // const [addContent, resultAddContent] = useAddContentMutation();  
  // const [updateContent] = useUpdateContentMutation();  



  const { data: allTemplates, isLoading: isLoadingTemplates } = useGetAllTemplatesQuery(5, { refetchOnMountOrArgChange: true })    
  // console.log("allTemplates: ", allTemplates)

  // const editorStatusParams = useAppSelector(state => state.editor.editorStatusParams)
  // console.log("editorStatusParams: ", editorStatusParams)
  
  const currPersistContent = useAppSelector(state => state.persistor._content.currContent)
  // console.log("currPersistContent: ", currPersistContent)

  const currPersistTemplate = useAppSelector(state => state.persistor._template.currTemplate)
  // console.log("currPersistTemplate in Save Template: ", currPersistTemplate)

  const [existTmpltNames, setExistTmpltNames] = useState<string[]>([])
  
  
  const { 
    register, 
    handleSubmit,
    // control,
    reset,
    watch,
    setError,
    formState:{
        errors,
        isLoading,         
        isValid,   
        isSubmitting,
        isSubmitSuccessful,        
    }
  } = useForm<any>({
      resolver: yupResolver(schema),
      defaultValues:{                 
        ...currPersistTemplate

        // template_id: "",
        // template_name : "custom L001",
        // width: 1920,
        // height: 1080,
        // target_layout: 0,   //0: landscape, 1: portrait
        // category: 2,    //1: public, 2: private
        // positions: [{
        //                 position_id: "",
        //                 template_id: "",
        //                 x: 0,
        //                 y:0,
        //                 w:1920,
        //                 h:1080,
        //                 layer: 1,
        //                 element_type: 'Video',
        //                 alias: 'custom_1',
        //                 default_source_id: '0',
        //                 selectable: 1
        // }]
      }
  })

  // console.log("template - watch ", watch())
  // ---------------------------------------------------
  



  // -------------------------------------
  const formSubmitHandler: SubmitHandler<any> = async (tmplt: Template) => {   
    // console.log("new template: ", tmplt)

    if (tmplt.template_name.length === 0){
      Swal.fire({
        title: 'Template Name',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },        
        icon: 'question',
        showConfirmButton: true,
        confirmButtonColor: '#9C258F',
        confirmButtonText: '<span class="mx-5"><i class="fa fa-save text-white me-2"></i>Save </span>',
        showCancelButton: true,
        cancelButtonText: '<span class="mx-5"><i class="fa fa-times text-white me-2"></i>Cancel </span>',
        showLoaderOnConfirm: true,
        preConfirm: (name) => {
            if (!name) {
              Swal.showValidationMessage('You need to write something!')
            }else{
              if (existTmpltNames.includes(name.toLowerCase())){
                Swal.showValidationMessage('This name already exist!')
              }
            } 
          return name        
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(async (result) => {
        if (result.isConfirmed) {
          const tmpltName = (result.value !== ""? result.value : "Tmplt 000")

          tmplt.template_name = tmpltName
          setTemplateName(tmpltName)
          dispatch(setTemplateName(tmpltName))

          try{
            // if(content.contentId === ""){

            //   // set status to Saving
            //   // -----------------------
            //   dispatch(setEditorStatusParams({...editorStatusParams, savingStatus: 1})) 

              //---generate thumbnails
              //----------------------------                             
              // const input = document.getElementById("editor-panel")                 
              // if (input){                  
                  const response :any = await addTemplate(tmplt)  
                  // console.log("response from addTemplate:", response)

                  const str = '<button class="btn tooltip-bottom btn-gradient-primary w-75 d-none" data-tooltip-content="Apply new template" data-bs-dismiss="modal" aria-label="Close">'+
                              '<i class="bi bi-lightning-fill text-white fs-4 me-2"></i>Let\' Apply Now!'+
                              '</button>'+
                              '<br/>&nbsp;'

                  if (response.data){
                    Swal.fire({
                      icon: 'success',
                      title:  'Your template has been created.<br/><br/>'+ str, 
                      showConfirmButton: false,
                      timer: 1000,
                      timerProgressBar: true
                    })

                    dispatch(setPrevTemplate(currPersistTemplate));
                    dispatch(setIsTemplateEditor(false));

                    //Reset content based on the new template
                    // ---------------------------------------------
                    const newTmplt : Template = response.data;
                    dispatch(setContentFromTemplate({   ...newTmplt, 
                                                        user_template_id: currPersistContent.user_template_id,
                                                        user_template_name: currPersistContent.user_template_name,
                                                    })); 

                    // set status to saved 
                    // ------------------
                    // dispatch(setEditorStatusParams({...editorStatusParams, savingStatus: 2})) 

                  }else{
                    Swal.fire({
                      icon: 'error',
                      title:  'Unable to create your template.<br/>', 
                      showConfirmButton: false,
                      timer: 1000,
                      timerProgressBar: true
                    })
                    
                    // dispatch(setEditorStatusParams({...editorStatusParams, savingStatus: 0})) // set status to unsaved                       
                  }
            //     })
            //     .catch(function (error) {
            //       console.error('oops, something went wrong!', error);
            //       dispatch(setEditorStatusParams({...editorStatusParams, savingStatus: 0})) // set status to unsaved 
            //     })
            //   } 
            // }
          }catch(error){
            Swal.fire(
                'Template: '+ tmplt.template_name,
                'There is something wrong during the creation!',
                'error'
            )
          } 
        }
      })        
    }else{ 
      // addTemplateHandler(tmplt)
    }
  }


  useEffect(()=>{
    setExistTmpltNames(allTemplates?allTemplates.map((tmplt: Template)=> tmplt.template_name.toLowerCase()):[])
  },[allTemplates])

  // -------------------------------------
  useEffect(() => {
   
    // //Assigned the prevContent for first time, after saving
    // if (prevPersistContent.user_template_name === "" && prevPersistContent.user_template_id === "" &&
    //     currPersistContent.user_template_name !== "" && currPersistContent.user_template_id !== ""){
    //       // console.log("save for the first time...........................")
    //       setTimeout(() => {
    //         dispatch(setPrevContent(currPersistContent))             
    //       }, 2000);
    // }

    // //----------
    // dispatch(enableEditorMode())
    // dispatch(setCurrentEditorWidth(currPersistContent.width))
    // dispatch(setCurrentEditorHeight(currPersistContent.height))
    // setContName(currPersistContent.user_template_name)


    // var eleList:any[] = []
    // currPersistContent.elements?.map((section, index) => {
    //   eleList.push({
    //     element_id  : section.element_id,
    //     position_id : section.position_id,
    //     alias       : section.alias,
    //     element_setting : JSON.stringify(section.element_setting),
    //     type            : section.element_type,
    //     source_ids      : JSON.stringify(section.sources),
    //   })
    // })

    const newTmplt = { ... currPersistTemplate
                      // contentId:  currPersistContent?currPersistContent.user_template_id:"",  
                      // user_template:{
                      //   user_template_name  : currPersistContent.user_template_name,
                      //   template_id         : currPersistContent.template_id,
                      //   duration            : currPersistContent.duration,          
                      // },
                      // elements: eleList
                    }
    reset(newTmplt)    
      
  }, [currPersistTemplate])
  
  // -------------------------------------------
  return (<>      
     
    <form id="frm-new-template" className='form d-inline'  
      onSubmit={handleSubmit(formSubmitHandler)}
    >
      {/* <input type="hidden" {...register("contentId")} value={currPersistContent.user_template_id} />
      <input type="hidden" {...register("user_template[user_template_name]")} value={contName} />
      <input type="hidden" {...register("user_template[template_id]")} value={currPersistContent.template_id} />
      <input type="hidden" {...register("user_template[duration]")} value={currPersistContent.duration} />
      {currPersistContent.elements?.map((section, index) => ( 
        <Fragment key={index}>
          <input type='hidden' {...register(`elements[${index}][element_id]`)} value={section.element_id} />
          <input type='hidden' {...register(`elements[${index}][position_id]`)} value={section.position_id} />
          <input type='hidden' {...register(`elements[${index}][alias]`)} value={section.alias} />
          <input type='hidden' {...register(`elements[${index}][element_setting]`)} value={JSON.stringify(section.element_setting)} />

          <input type='hidden' {...register(`elements[${index}][type]`)} value={section.element_type} />
          <input type='hidden' {...register(`elements[${index}][source_ids]`)} value={JSON.stringify(section.sources)} />
        </Fragment> 
      ))} */}

      {/* <button 
        type='button'
        className='btn btn-link'
        onClick={printDocument}>
        print
      </button> */}
      {/* <button 
        type="submit" 
        className={`btn btn-primary btn-sm tooltip-bottom`} 
        // data-tooltip-content={currPersistContent.user_template_id === "" ? "Save new template": "Save template"}        
        // disabled={isSubmitting || !(isValid && ([0].includes(editorStatusParams.savingStatus)) )}
      >
        Save Template
      </button>  */}
      <button 
        type="submit" 
        className={`btn btn-primary btn-sm tooltip-bottom`} 
        // data-tooltip-content={currPersistContent.user_template_id === "" ? "Save new content": "Save content"}        
        // disabled={isSubmitting || !(isValid && ([0].includes(editorStatusParams.savingStatus)) )}
      >
        <span><i aria-hidden="true" className="fs-4 mt-n1 fa fa-save"></i> Save Template</span>
        {/* {
          [-1,0,2].includes(editorStatusParams.savingStatus)  
            ? <span><i aria-hidden="true" className="fs-4 mt-n1 fa fa-save"></i> Save</span>
            : [1].includes(editorStatusParams.savingStatus) &&  
                <div className='d-flex'>
                  <div className="spinner-border w-15px h-15px me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span>Saving</span>
                </div>                    
        } */}        
        
      </button>      
       
    </form> 
  </>)
}

export {SaveTemplateFrm}
